import axios from 'axios';

export default {
  getPostIdx (idx) { // 글 하나 상세
    return new Promise((resolve, reject) => {
      axios.get(`/v5/post/${idx}`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPost (formData) { // 글 생성
    return new Promise((resolve, reject) => {
      axios.post(`/v5/post`, formData).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPostIdxLike (idx) { // 글 좋아요
    return new Promise((resolve, reject) => {
      axios.post(`/v3/post/${idx}/like`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPostIdxBookmark (idx) { // 글 북마크
    return new Promise((resolve, reject) => {
      axios.post(`/v3/post/${idx}/bookmark`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPostIdxHide (idx) { // 글 숨기기
    return new Promise((resolve, reject) => {
      axios.post(`/v3/post/${idx}/hide`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  deletePostIdx (idx) { // 글 삭제
    return new Promise((resolve, reject) => {
      axios.delete(`/v3/post/${idx}`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPostIdxComment (idx, content) { // 댓글 작성
    return new Promise((resolve, reject) => {
      axios.post(`/v3/post/${idx}/comment`, {
        post_idx: idx,
        contents: content
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPostIdxCommentIdxRecomment (postIdx, commentIdx, content) { // 대댓글 작성
    return new Promise((resolve, reject) => {
      axios.post(`/v3/post/${postIdx}/comment/${commentIdx}/recomment`, {
        post_idx: postIdx,
        comment_idx: commentIdx,
        contents: content
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPostIdxCommentIdxLike (postIdx, commentIdx) { // 댓글 좋아요
    return new Promise((resolve, reject) => {
      axios.post(`/v3/post/${postIdx}/comment/${commentIdx}/like`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPostIdxRecommentIdxLike (postIdx, commentIdx, recommentIdx) { // 대댓글 좋아요
    return new Promise((resolve, reject) => {
      axios.post(`/v3/post/${postIdx}/comment/${commentIdx}/recomment/${recommentIdx}/like`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPostIdxCommentIdxReport (postIdx, commentIdx) { // 댓글 신고
    return new Promise((resolve, reject) => {
      axios.post(`/v3/post/${postIdx}/comment/${commentIdx}/report`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPostIdxRecommentIdxReport (postIdx, commentIdx, recommentIdx) { // 대댓글 신고
    return new Promise((resolve, reject) => {
      axios.post(`/v3/post/${postIdx}/comment/${commentIdx}/recomment/${recommentIdx}/report`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  deletePostIdxCommentIdx (postIdx, commentIdx) {
    return new Promise((resolve, reject) => {
      axios.delete(`/v3/post/${postIdx}/comment/${commentIdx}`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  deletePostIdxCommentIdxRecommentIdx (postIdx, commentIdx, recommentIdx) {
    return new Promise((resolve, reject) => {
      axios.delete(`/v3/post/${postIdx}/comment/${commentIdx}/recomment/${recommentIdx}`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getPostIdxComment (second, idx, page) { // 댓글 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v3/post/${idx}/comment`, {
        params: {
          time: second,
          page,
          count: 20,
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getPostIdxCommentIdxRecomment (second, postIdx, commentIdx, offset) { // 대댓글 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v3/post/${postIdx}/comment/${commentIdx}/recomment`, {
        params: {
          time: second,
          offset,
          count: 5,
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
}

